// YNX — Billing API client
const API = process.env.REACT_APP_BACKEND_URL;

const wsId = () => {
  try { return localStorage.getItem('ynx_workspace_id') || ''; }
  catch (err) { console.warn('YNX billing: localStorage read failed', err); return ''; }
};

const headers = (extra = {}) => ({
  'Content-Type': 'application/json',
  ...(wsId() ? { 'X-YNX-Workspace': wsId() } : {}),
  ...extra,
});

const json = async (res) => {
  if (!res.ok) {
    let err = `HTTP ${res.status}`;
    try { const j = await res.json(); err = j.detail || err; }
    catch (e) { console.debug('billing: response not JSON, keeping HTTP code', e); }
    throw new Error(err);
  }
  return res.json();
};

export const listPackages = () =>
  fetch(`${API}/api/biz/billing/packages`).then(json);

export const createCheckout = (packageId) =>
  fetch(`${API}/api/biz/billing/checkout`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ package_id: packageId, origin_url: window.location.origin }),
  }).then(json);

export const getCheckoutStatus = (sessionId) =>
  fetch(`${API}/api/biz/billing/checkout/status/${sessionId}`, { headers: headers() }).then(json);
